<template>
  <v-flex xs12>
    <v-card light color="white" class="ma-3 depressed">
      <v-layout row wrap>
        <v-flex :class="'xs'+(labelIncorrect?'12':'11')" :style="taskBg">
          <v-layout row wrap  v-if="context!='interact-pj'">
            <v-flex xs1 class="text-xs-center">
              <v-avatar color="grey lighten-4" size="36" style="margin-top:30%">
                <span class="body-1">{{taskIndex+1}}</span>
              </v-avatar>
            </v-flex>
            <v-flex md10 xs12 class="text-xs-center">
              <v-layout row wrap>
                <template v-if="attributionsView!='replicated'">
                  <v-flex md2 xs12></v-flex>
                  <v-flex md10 xs12>
                    <v-card-text
                      class="subheading text-xs-center"
                      v-html="displayedText(usedClassifierNames,selectedClassifier)"
                    ></v-card-text>
                  </v-flex>
                </template>

                <v-flex
                  v-for="(classifierName,classifierIndex) in usedClassifierNames"
                  :key="classifierIndex"
                  xs12
                >
                  <v-layout row wrap>
                    <template v-if="attributionsView=='replicated'">
                      <v-flex md2 xs12></v-flex>
                      <v-flex md10 xs12>
                        <v-card-text
                          class="subheading text-xs-center"
                          v-html="displayedText(usedClassifierNames,classifierIndex )"
                        ></v-card-text>
                      </v-flex>
                    </template>
                    <v-flex md2 xs12>
                      <v-tooltip
                        color
                        :open-delay="2000"
                        right
                        :disabled="attributionsView==='replicated'"
                      >
                        <v-chip
                          slot="activator"
                          @mouseenter="updateSelectedClassifier(classifierIndex)"
                          @mouseleave="updateSelectedClassifier(null)"
                          label
                          :text-color="classifierIndex===selectedClassifier?'white':''"
                          :outline="classifierIndex!==selectedClassifier"
                          :color="classifierSchemes[classifierIndex].color"
                          style="margin-right:5%"
                        >{{classifierName}} classifier</v-chip>
                        <span>Highlight words affecting classifier</span>
                      </v-tooltip>
                    </v-flex>
                    <v-flex md10 xs12>
                      <v-item-group active-class="v-card--active" class="text-xs-center">
                        <v-item
                          v-for="(l,i) in taskData.predictions[classifierName].preds"
                          :key="l.label"
                        >
                          <v-chip
                            slot-scope="{ active}"
                            :selected="active"
                            :style="l.style"
                            @click="clickLabel(i,classifierName)"
                          >
                            <v-avatar class="white" style="color:black">{{Math.round(l.score*100)}}</v-avatar>
                            {{l.label}}
                          </v-chip>
                        </v-item>
                      </v-item-group>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs1 class="text-xs-center">
              <v-tooltip top v-if="debuggerMode">
                <v-btn
                  slot="activator"
                  fab
                  small
                  depressed
                  color="grey lighten-4"
                  style="margin-top:30%"
                >
                  <v-icon color="grey">help</v-icon>
                </v-btn>
                <span>
                  data: {{JSON.stringify(taskData.labels,null,4)}}
                  <br>
                  users: {{JSON.stringify(userInfo.stats,null,4)}}
                </span>
              </v-tooltip>

              <v-tooltip top v-if="!debuggerMode && context!='interact'">
                <v-btn
                  slot="activator"
                  @click="removeTask(taskIndex)"
                  fab
                  small
                  depressed
                  color="grey lighten-4"
                  style="margin-top:30%"
                >
                  <v-icon color="grey">close</v-icon>
                </v-btn>
                <span>Ignore this item.</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
          <v-flex v-show="!labelIncorrect" xs1 @click="updateStatus($event)">
            <v-card :color="checkerColor" height="100%" class="text-xs-center">
              <v-btn x-large icon style="margin-top:30%">
                <v-icon color="white" x-large>{{checkerIcon}}</v-icon>
              </v-btn>
            </v-card>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import { getStyles, rescale_score_by_abs } from "@/services/colormapping.js";
import _ from "lodash";

export default {
  name: "task",
  data() {
    return {
      selectedClassifier: null,
      colorSchemes: ["bwr", "PuOr", "BrBG", "RdGy", "PiYG"]
    };
  },
  props: {
    context: String,
    taskData: Object,
    taskIndex: Number
  },
  computed: {
    ...mapGetters("labeling", {
      userInfo: "userInfo",
      savedIndex: "savedIndex",
      stats: "stats",
      debuggerMode: "debuggerMode",
      attributionsView: "attributionsView",
      classifierNames: "classifierNames",
      labelingMode: "labelingMode"
    }),
    usedClassifierNames() {
      if (this.taskData) {
        return _.intersection(Object.keys(this.taskData.predictions), this.classifierNames);
      } else {
        return [];
      }
    },
    labelIncorrect() {
      return this.labelingMode === "labelIncorrect";
    },
    // targetLabelsMap() {
    //   let targetLabelsMap = {};
    //   for (let classifierName in this.taskData.predictions) {
    //     let preds = this.taskData.predictions[classifierName].preds;
    //     targetLabelsMap[classifierName] = _.map(preds, "label");
    //   }
    //   return targetLabelsMap;
    // },
    checkerColor() {
      return this.taskData.status === "checked"
        ? this.labelIncorrect
          ? "red lighten-3"
          : "green lighten-3"
        : this.labelIncorrect
        ? "green lighten-5"
        : "amber  lighten-3";
    },
    taskBg() {
      let color =
        this.taskData.status === "checked"
          ? this.labelIncorrect
            ? "#FFEBEE"
            : "#E8F5E9"
          : this.labelIncorrect
          ? "white"
          : "white";
      return { "background-color": color };
    },
    checkerIcon() {
      return this.taskData.status === "checked"
        ? this.labelIncorrect
          ? "report"
          : "check_box"
        : this.labelIncorrect
        ? "check_box"
        : "indeterminate_check_box";
    },
    classifierSchemes() {
      let result = [];
      for (let i = 0; i < this.usedClassifierNames.length; i++) {
        const cname = this.usedClassifierNames[i];
        const scheme = this.colorSchemes[i % this.colorSchemes.length];
        result.push({
          classifierName: cname,
          scheme: scheme,
          color: getStyles(0.8, scheme)["background-color"]
        });
      }
      return result;
    }
  },
  methods: {
    ...mapActions("labeling", {
      updateSelections: "updateSelections",
      updateStats: "updateStats",
      removeTask: "removeTask",
      chooseMaxLabel: "chooseMaxLabel",
      setSavedIndex: "setSavedIndex"
    }),
    updateSelectedClassifier(classifierIndex) {
      this.selectedClassifier = classifierIndex;
    },
    joinTexts(tokens) {
      let text = "";
      for (let i = 0; i < tokens.length; i++) {
        let token = tokens[i];
        let stylesStr = "";
        for (let key in token.styles) {
          stylesStr += key + ":" + token.styles[key] + ";";
        }
        if (token.text == "@") {
          token.text = "@twitter_user";
        }
        text +=
          (token.text.indexOf("▁") === 0 ? "<span style='font-size:0; margin-right:5px'></span>" : "") +
          "<span style='" +
          stylesStr +
          "'>" +
          token.text.replace("▁", "") +
          "</span>";
      }
      return text;
    },
    displayedText(usedClassifierNames, targetClassifier) {
      let selectedTokenList = null;
      if (this.attributionsView === "on demand") {
        selectedTokenList = this.stylizeTexts(usedClassifierNames, false, this.selectedClassifier);
      } else if (this.attributionsView === "show all") {
        selectedTokenList = this.stylizeTexts(
          usedClassifierNames,
          this.selectedClassifier === null,
          this.selectedClassifier
        );
      } else if (this.attributionsView === "replicated") {
        selectedTokenList = this.stylizeTexts(usedClassifierNames, false, targetClassifier);
      }
      if (!selectedTokenList || selectedTokenList.length === 0) {
        return this.taskData.text;
      } else {
        return this.joinTexts(selectedTokenList);
      }
    },
    stylizeTexts(usedClassifierNames, overlapping, targetClassifier) {
      let newTokenList = this.taskData.tokens.map(t => ({
        text: t,
        styles: { display: "inline-block" }
      }));
      for (let c = 0; c < usedClassifierNames.length; c++) {
        if (!overlapping) {
          if (targetClassifier === null) {
            break;
          } else if (targetClassifier !== c) {
            continue;
          }
        }
        const classifierName = usedClassifierNames[c];
        let scores = this.taskData.predictions[classifierName].attributions;
        // no attributions computed
        if (!scores) {
          continue;
        }
        let max_s = Math.max(...scores);
        let min_s = Math.min(...scores);

        for (let i = 0; i < newTokenList.length; i++) {
          if (i >= scores.length) {
            //  the maximum number of tokens taken into account can vary across classifiers.
            break;
          }
          let token = newTokenList[i];
          let score = rescale_score_by_abs(scores[i], max_s, min_s);
          let styles = getStyles(score, this.classifierSchemes[c].scheme);
          if (!token.styles["background-color"]) {
            token.styles["background-color"] = styles["background-color"];
          }
          if (styles["color"] === "rgb(255,255,255)") {
            token.styles["color"] = styles["color"];
          }
          // token.styles = { ...token.styles, ...styles };
        }
      }
      return newTokenList;
    },
    async chooseLabel(i, classifierName) {
      // highlight the chosen label and clear the other labels
      for (let j = 0; j < this.taskData.predictions[classifierName].preds.length; j++) {
        const l = this.taskData.predictions[classifierName].preds[j];
        if (i === j) {
          l.chosen = true;
          l.style = {
            "background-color": this.labelIncorrect ? "#EF9A9A" : "#A5D6A7"
          };
        } else {
          l.chosen = false;
          l.style = {
            "background-color": this.labelIncorrect ? "#e0e0e0" : "#e0e0e0"
          };
        }
        await this.$nextTick();
      }
    },
    clickLabel(i, classifierName) {
      if (this.debuggerMode || this.context === "interact") {
        return;
      }
      this.taskData.status = "checked";

      // make item chosen
      this.chooseLabel(i, classifierName);
      // save the current index to allow range selection
      this.setSavedIndex(this.taskIndex);
    },
    updateStatus(evt) {
      let index = this.taskIndex;
      const savedIndex = this.savedIndex;
      this.setSavedIndex(index);

      let normalClick = false;
      // If this is the first pass or no shift key was
      // pressed, just bail.
      if (savedIndex === null || !evt.shiftKey) {
        normalClick = true;
      }

      // Shift-clicked the same message :-/
      if (index === savedIndex) {
        normalClick = true;
      }

      // single click, no range selection
      if (normalClick) {
        if (this.taskData.status === "unknown") {
          this.taskData.status = "checked";
          // choose the max label
          this.chooseMaxLabel({ initial: false, taskData: this.taskData });
        } else if (this.taskData.status === "checked") {
          // clear the selection, revert back to max score with amber color
          this.taskData.status = "unknown";
          this.chooseMaxLabel({ initial: true, taskData: this.taskData });
        }
      } else {
        this.updateSelections({
          savedIndex: savedIndex,
          index: this.taskIndex
        });
      }
    }
  },
  updated() {
    if (this.debuggerMode) {
      for (const classifierName in this.stats) {
        let predicted = this.taskData["raw"][classifierName].predicted;
        let expected = this.taskData["raw"][classifierName].expected;
        let expectedIndex = this.taskData["raw"][classifierName].expected_index;
        if (expected === null) {
          continue;
        }
        //  if the most frequent label is also the highest score, then no mistake was found
        else if (expected === predicted) {
          this.chooseMaxLabel({
            initial: true,
            taskData: this.taskData,
            classifierNames: [classifierName]
          });
        } else {
          // otherwise set this as a mistake
          // this.taskData.status = "checked";
          this.chooseLabel(expectedIndex, classifierName);
        }
      }
    } else {
      this.chooseMaxLabel({ initial: true, taskData: this.taskData });
    }
  },
  created() {
    if (!this.debuggerMode) {
      this.chooseMaxLabel({ initial: true, taskData: this.taskData });
    }
  }
};
</script>

<style scoped>
.v-card--active {
}
</style>
